import store from '@/store';
import router from '@/router';
import api from '@/api';

export default {
	async getSchoolSummary () {
		try {
			let persistent = store.state.persistent;
			if (!persistent.academicYear || !persistent.school || !persistent.schools) {
				router.push('/coaching/schools');
				return;
			}
			let schoolId = persistent.school.id;
			await store.dispatch('clearSchoolSummary');
			let response = await api.coaching.getSchoolSummary(schoolId);
			await store.dispatch('setSchoolSummary', response.data.summary);
			await store.dispatch('setSchoolCategoriesSummary', response.data.summaryCategories);
			if (response.status == 204) await store.dispatch('showNoData');
			else await store.dispatch('hideNoData');
		} catch (error) {
			throw error;
		}
	},

	async getSchoolProgress () {
		try {
			let schoolId = store.state.persistent.school.id;
			await store.dispatch('clearSchoolProgress');
			let response = await api.coaching.getSchoolProgress(schoolId);
			await store.dispatch('setSchoolProgress', response.data.progress);
		} catch (error) {
			throw error;
		}
	},

	async getSchoolLanguagesSummary () {
		try {
			let schoolId = store.state.persistent.school.id;
			await store.dispatch('clearSchoolLanguagesSummary');
			let response = await api.coaching.getSchoolLanguagesSummary(schoolId);
			await store.dispatch('setSchoolLanguagesSummary', response.data.summary);
		} catch (error) {
			throw error;
		}
	},

	async getSchoolLanguagesProgress () {
		try {
			let schoolId = store.state.persistent.school.id;
			await store.dispatch('clearSchoolLanguagesProgress');
			let response = await api.coaching.getSchoolLanguagesProgress(schoolId);
			await store.dispatch('setSchoolLanguagesProgress', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getSchoolAcademicLevelsProgress () {
		try {
			let schoolId = store.state.persistent.school.id;
			await store.dispatch('clearSchoolAcademicLevelsProgress');
			let response = await api.coaching.getSchoolAcademicLevelsProgress(schoolId);
			await store.dispatch('setSchoolAcademicLevelsProgress', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getSchoolAcademicLevelsSummary () {
		try {
			let schoolId = store.state.persistent.school.id;
			await store.dispatch('clearSchoolAcademicLevelsSummary');
			let response = await api.coaching.getSchoolAcademicLevelsSummary(schoolId);
			await store.dispatch('setSchoolAcademicLevelsSummary', response.data.summary);
		} catch (error) {
			throw error;
		}
	},

	async getSchoolTeachersProgress () {
		try {
			let schoolId = store.state.persistent.school.id;
			await store.dispatch('clearSchoolTeachersProgress');
			let response = await api.coaching.getSchoolTeachersProgress(schoolId);
			await store.dispatch('setSchoolTeachersProgress', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getSchoolTeachersSummary () {
		try {
			let schoolId = store.state.persistent.school.id;
			await store.dispatch('clearSchoolTeachersSummary');
			let response = await api.coaching.getSchoolTeachersSummary(schoolId);
			await store.dispatch('setSchoolTeachersSummary', response.data.summary);
		} catch (error) {
			throw error;
		}
	},

	async setSchool (school) {
		try {
			await store.dispatch('hideContent');
			await store.dispatch('setSchool', school);
			await this.getAcademicYearsByCountry(school.countryCode);
			let persistent = store.state.persistent;
			if (!persistent.academicYears || persistent.academicYears.length == 0) return;
			await store.dispatch('setAcademicYear', persistent.academicYears[persistent.academicYears.length - 1]);
			await router.push('/coaching/school');
			setTimeout(async () => {
				await store.dispatch('showContent');
			}, 2000);
		} catch (error) {
			await store.dispatch('showContent');
			throw error;
		}
	},

	async setAcademicYear (academicYear) {
		try {
			await store.dispatch('hideContent');
			await store.dispatch('setAcademicYear', academicYear);
			await router.go();
			setTimeout(async () => {
				await store.dispatch('showContent');
			}, 2000);
		} catch (error) {
			await store.dispatch('showContent');
			throw error;
		}
	},

	async getAdminSchools () {
		try {
			await store.dispatch('clearAdminSchools');
			let response = await api.coaching.getAdminSchools();
			await store.dispatch('setAdminSchools', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getSummarySchools () {
		try {
			await store.dispatch('clearSummarySchools');
			let response = await api.coaching.getSummarySchools();
			await store.dispatch('setSummarySchools', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getAdminSchoolHistory (schoolId) {
		try {
			await store.dispatch('clearAdminSchoolHistory');
			let response = await api.coaching.getAdminSchoolHistory(schoolId);
			await store.dispatch('setAdminSchoolHistory', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getAdminSchoolHistoryByTypeId (schoolId, synthesisTypeId) {
		try {
			let response;
			await store.dispatch('clearAdminSchoolHistory');
			if (synthesisTypeId == 6) response = await api.coaching.getAdminSchoolEvaluations(schoolId);
			else if (synthesisTypeId == 4) response = await api.coaching.getAdminSchoolIssues(schoolId);
			else response = await api.coaching.getAdminSchoolHistoryByTypeId(schoolId, synthesisTypeId);
			await store.dispatch('setAdminSchoolHistory', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getSynthesesReportByTypeId (synthesisTypeId, startDate = null, endDate = null) {
		try {
			await store.dispatch('clearAdminSchoolHistory');
			let response = await api.coaching.getSynthesesReportByTypeId(synthesisTypeId, startDate, endDate);
			await store.dispatch('setAdminSchoolHistory', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getHistoryByTypeId (synthesisTypeId) {
		try {
			let response;
			await store.dispatch('clearAdminSchoolHistory');
			if (synthesisTypeId == 6) response = await api.coaching.getAdminEvaluations();
			else if (synthesisTypeId == 4) response = await api.coaching.getAdminIssues();
			else response = await api.coaching.getHistoryByTypeId(synthesisTypeId);
			await store.dispatch('setAdminSchoolHistory', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getSynthesesDashboardByTypeId (synthesisTypeId, startDate = null, endDate = null) {
		try {
			await store.dispatch('clearAdminSynthesesDashboard');
			let response = await api.coaching.getSynthesesDashboardByTypeId(synthesisTypeId, startDate, endDate);
			await store.dispatch('setAdminSynthesesDashboard', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getEvaluation (evaluationId) {
		try {
			await store.dispatch('clearAdminEvaluation');
			let response = await api.coaching.getEvaluation(evaluationId);
			await store.dispatch('setAdminEvaluation', response.data);
		} catch (error) {
			console.log(error);
		}
	},

	async getIssue (issueId) {
		try {
			await store.dispatch('clearAdminIssue');
			let response = await api.coaching.getIssue(issueId);
			await store.dispatch('setAdminIssue', response.data);
		} catch (error) {
			console.log(error);
		}
	},

	async getSynthesis (synthesisId) {
		try {
			await store.dispatch('clearAdminSynthesis');
			let response = await api.coaching.getSynthesis(synthesisId);
			await store.dispatch('setAdminSynthesis', response.data);
		} catch (error) {
			console.log(error);
		}
	},

	async getTrainingTalks () {
		try {
			await store.dispatch('clearTrainingTalks');
			let response = await api.coaching.getTrainingTalks();
			await store.dispatch('setTrainingTalks', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getSchools () {
		try {
			await store.dispatch('clearSchools');
			let response = await api.coaching.getSchools();
			await store.dispatch('setSchools', response.data);
		} catch (error) {
			throw error;
		}
	},

	async getAcademicYearsByCountry (countryCode) {
		try {
			await store.dispatch('clearAcademicYears');
			let response = await api.coaching.getAcademicYears();
			let academicYears = response.data.filter((academicYear) => (academicYear.countryCode == countryCode));
			await store.dispatch('setAcademicYears', academicYears);
		} catch (error) {
			throw error;
		}
	},

	async setVisit (visit) {
		try {
			await store.dispatch('hideContent');
			await store.dispatch('setVisit', visit);
			router.go();
		} catch (error) {
			throw error;
		}
	}
};



// WEBPACK FOOTER //
// ./src/mediator/coaching.js